<template>
  <section class="h_05">
    <div class="alive_content">
      <div class="title f-center-title">
        <div>全场景一镜到底</div>
      </div>
      <div class="des f-center-sub-title">
        <div>
          将智驾核心用车场景嵌入系统框架，深度定制跨应用、跨场景、跨引擎、行泊停全场景的丝滑体验
        </div>
      </div>
    </div>
    <div class="video_container">
      <div class="border_container_night" v-ia>
        <m-video
          poster="@/v2/mobile/assets/video/poster/v_05.webp"
          src="@/v2/mobile/assets/video/v_5.mp4"
          muted
          x5-playsinline
          playsinline
          webkit-playsinline="true"
          autoplay
          ref="video"
        ></m-video>
      </div>
      <replay
        class="alive_replay"
        @click="() => replayVideo(this.$refs.video)"
      />
    </div>
    <m-img class="h_05_2" src="@/v2/mobile/assets/image/h_05_2.png"></m-img>
  </section>
</template>
<script>
import { videoPlayByVisibleAreaH5, replayVideo } from '@/utils'

import replay from '@/components/replay.vue'
export default {
  name: 'h_05',
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    videoPlayByVisibleAreaH5(this.$refs.video)
  },
  methods: {
    replayVideo,
  },
}
</script>
<style lang="less" scoped>
.h_05 {
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 100px 24px 0;
  position: relative;
  background-color: #000;
  .title {
    padding-top: 100px;
    display: flex;
    flex-direction: column;
    width: max-content;
    line-height: 1.4;
    font-size: 34px;
    // 设置背景
    background: radial-gradient(
        338.46% 210.42% at 34.4% -85.42%,
        #a2cdff 0%,
        #ffffff 100%
      )
      /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
    // 背景作用于字体上
    background-clip: text;
    // 字体透明
    color: transparent;
    font-weight: 700;
  }
  .des {
    margin-top: 16px;
    color: #ffffff80;
    text-align: justify;
  }
  .video_container {
    width: 100%;
    top: 30%;
    margin-top: 57px;
    video {
      width: 100%;
    }
    .alive_replay {
      margin-top: 22px;
      margin-left: 3px;
      color: #3b82fc;
    }
  }
  .h_05_2 {
    width: calc(100% - 60px);
    margin-top: 32px;
  }
}
</style>
